// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2_m0N","title":"InfoRow_title__eEF99"};